import { Container } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css/navigation";
import "swiper/css";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import LineData from "./LineData";

export default function ChartsSection({ chartData }) {
  return (
    <div>
      <h4 style={{ fontWeight: "bold" }}>
        <FormattedMessage id="the-new-in" />{" "}
        <FormattedMessage id="statistics" />
      </h4>
      <br />
      <div className="slider-chart-new mb-5">
        {chartData.length > 0 ? (
          <Swiper
            modules={[Navigation]}
            navigation={{
              prevEl: ".next",
              nextEl: ".prev",
            }}
            spaceBetween={20}
            slidesPerView={1}
            dir="ltr"
            loop
          >
            {chartData.map((el, i) => (
              <SwiperSlide key={i}>
                <Container
                  style={{
                    border: "2px solid var(--main-color)",
                    borderRadius: "20px",
                    paddingTop: "1rem",
                  }}
                >
                  <center>
                    <br />
                    <LineData data={el} publication={el?.publication} />
                  </center>
                </Container>
              </SwiperSlide>
            ))}
            <div className="prev">
              <i className="fa fa-angle-left"></i>
            </div>
            <div className="next">
              <i className="fa fa-angle-right"></i>
            </div>
          </Swiper>
        ) : (
          <DataNotFound />
        )}
      </div>
    </div>
  );
}
